import { useClinicalProtocolsEnabled } from '@/hooks/useClinicalProtocolsEnabled';
import { ProtocolDetail } from '@/pages/ProtocolViewer/ProtocolDetail';
import { createFileRoute } from '@tanstack/react-router';

const RouteComponent = (): React.ReactNode => {
  // oxlint-disable-next-line no-use-before-define
  const { canonical } = Route.useParams();
  if (!useClinicalProtocolsEnabled()) return null;
  return <ProtocolDetail canonical={canonical} />;
};

export const Route = createFileRoute('/_auth/internal/protocols/$canonical')({ component: RouteComponent });
